import { useLocation } from 'react-router-dom'

export const useQueryParams = (searchFor, defaultValue?: any): any => {
  const query: any = new URLSearchParams(useLocation().search)
  return query.get(searchFor) || defaultValue || null
}

export default useQueryParams
